/**
 * Stringify Object to the query string and return it as String
 * @param  {Object} params
 * @param {String} prefix
 * @return {String}
 */
export default function getQueryString(params, prefix) {
  const esc = encodeURIComponent

  return Object.keys(params).map((k) => {
    const key = prefix ? prefix.concat('[', k, ']') : k
    const value = params[k]

    return (value !== null && typeof value === 'object')
      ? getQueryString(value, key)
      : esc(key).concat('=', esc(value))
  }).join('&')
}
